import React from 'react';
interface Props {
  onClick: () => void;
  hidden?: boolean;
}

export default function FloatingButton({ onClick, hidden }: Props) {
  if (hidden) return null;
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        position: 'fixed',
        right: 28,
        bottom: 28,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '12px 20px 12px 14px',
        borderRadius: 999,
        border: 'none',
        cursor: 'pointer',
        background: 'linear-gradient(135deg, #2A6FF5 0%, #5B8DEF 100%)',
        color: '#fff',
        fontSize: 14,
        fontWeight: 500,
        letterSpacing: 0.3,
        boxShadow: '0 8px 24px rgba(42,111,245,0.35), 0 2px 6px rgba(42,111,245,0.2)',
        transition: 'transform 0.18s cubic-bezier(0.4,0,0.2,1), box-shadow 0.18s'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 12px 30px rgba(42,111,245,0.45), 0 3px 8px rgba(42,111,245,0.25)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 8px 24px rgba(42,111,245,0.35), 0 2px 6px rgba(42,111,245,0.2)';
      }}
    >
      <span
        style={{
          width: 24,
          height: 24,
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.2)',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <svg viewBox="0 0 24 24" fill="none" width={14} height={14}>
          <path d="M14 2L5 13.5h6.5L10 22l9.5-11H13L14 2Z" fill="#fff" />
        </svg>
      </span>
      问 AI 助手
    </button>
  );
}
